import * as React from 'react';
import StyledSVG from './styled.js';

/** @deprecated */
const SonntagIcon = ({ iconPath = '', color = '', hover = '', size = 24, ...rest }) => (React.createElement(StyledSVG, { ...rest, color: color, hover: hover, width: `${size}px`, height: `${size}px`, viewBox: "0 0 1024 1024", xmlns: "http://www.w3.org/2000/svg" },
    React.createElement("path", { d: iconPath })));

export { SonntagIcon };
